module.exports = __webpack_public_path__ + "img/142.1d1052fb.jpg";